import React, { useState, useEffect, useRef } from 'react';
import { MoreVertical } from 'lucide-react';

export const ActionMenu = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative" ref={menuRef}>
            <button onClick={() => setIsOpen(!isOpen)} className="p-2 rounded-full hover:bg-gray-200">
                <MoreVertical size={20} />
            </button>
            {isOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10 border">
                    <ul className="py-1">
                        {React.Children.map(children, child =>
                           React.cloneElement(child, { closeMenu: () => setIsOpen(false) })
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export const ActionMenuItem = ({ icon, label, onClick, closeMenu }) => (
    <li>
        <a href="#" onClick={(e) => { e.preventDefault(); onClick(); if(closeMenu) closeMenu(); }}
           className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
            {icon}
            <span className="ml-3">{label}</span>
        </a>
    </li>
);